import { render, staticRenderFns } from "./JournalPublishManagement.vue?vue&type=template&id=2d20b280&scoped=true"
import script from "./JournalPublishManagement.vue?vue&type=script&lang=js"
export * from "./JournalPublishManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d20b280",
  null
  
)

export default component.exports